export default {
  sekundarstufen: {
    fetching: false,
    fetched: false,
    data: null
  },
  error: null
}
